<template>
  <!-- 手动指定效期 -->
  <div style="" class="SED cus-modal" v-loading="loading">
    <OmsButton :btn-config="btnConfig" class="btn_top" />
    <Table :key="tableFresh" :columns="columns" :data="tableData" height="300" class="ark_table"></Table>
    <OmsButton :btn-config="btnConfig2" class="modal-footer" />
  </div>
</template>

<script>
import listeningToKeydownMixin from '@/assets/js/mixins/listeningToKeydown.js';
import expandRow from './SED-expand.vue';

export default {
  components: { expandRow },
  mixins: [listeningToKeydownMixin],
  props: {
    componentData: {}
  },
  watch: {
    tableData: {
      handler(n) {
        console.log('watch::');
        n.forEach(it => {
          console.log('it::', it);
          if (it.appoint_type == 3) {
            if (it.date_num.length) {
              it._expanded = true
              it.date_num.forEach((x, y) => {
                x.key = `${y}_${x.date}_${x.num}`
              })
            } else {
              it._expanded = false
            }
            it._disableExpand = false
          } else {
            it._disableExpand = true // 展示折叠icon与否
            it._expanded = false // 是否为展开状态
          }
        })
        // this.request(newVal);
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      tableFresh: +new Date(),
      loading: '',
      columns: [
        {
          type: 'expand',
          width: 40,
          render: (h, params) => {
            const _this = this
            return h(expandRow, {
              props: {
                params: _.cloneDeep(params),
                // data: _this.data
              },
              on: {
                deleteRule: (...arg) => { this.handleRule(-1, arg) },
                dataChange: (params) => {
                  console.log('dataChange::', params);
                  _this.tableData[params.index] = params.row;
                  // _this.tableData = this.handlerTableData(_.cloneDeep(this.tableData));
                },
              }
            })
          }
        },
        {
          title: t('序号'),
          type: 'index',
          width: 50,
          align: 'center'
        },
        { "title": t("SPU编码"), "key": "sku_code", "__id": "u2uDXK" },
        { "title": t("SPU名称"), "key": "sku_title", "__id": "fkS53654hkX" },
        { "title": t("销售数量"), "key": "qty", "__id": "fkShkX" },
        {
          "title": t("效期类型"), "key": "appoint_type", "__id": "osIjQE",
          render: (h, params) => {
            return h('Select', {
              style: {
                // padding: '3px'
              },
              props: {
                transfer: true,
                clearable: false,
                value: params.row.appoint_type,
              },
              nativeOn: {
                click: (e) => {
                  e.stopPropagation();
                }
              },
              on: {
                'on-change': (val, e) => {
                  if (val == undefined) { // 清空情况处理
                    val = 1
                  }
                  params.row.appoint_type = val;
                  const newRule = {date: '', num: params.row.qty};
                  params.row.start_date_day = '';
                  params.row.end_date_day = '';
                  params.row.date_num = val === 3 ? [newRule] : [];
                  this.tableData[params.index] = params.row;
                  this.tableData = this.handlerTableData(_.cloneDeep(this.tableData)); // select 变更没有触发watch
                  console.log('row::', this.tableData[params.index]); // 0找不到？
                }
              }
            }, this.selectOptionRender(h))
          }
        },
        {
          "title": t("开始生产日期/天数"), "key": "start_date_day", "__id": "osI2j3QE",
          render: (h, params) => {
            if (params.row.appoint_type === 3) {
              return ''
            }
            return h('Input', {
              props: {
                placeholder: t('请输入'),
                value: params.row.start_date_day,
              },
              on: {
                'on-blur': (e) => {
                  const val = e.target.value
                  console.log('val::', val);
                  params.row.start_date_day = val;
                  this.tableData[params.index].start_date_day = val;
                }
              }
            })
          }
        },
        {
          "title": t("结束生产日期/天数"), "key": "end_date_day", "__id": "os1IjQE",
          render: (h, params) => {
            if (params.row.appoint_type === 3) {
              return ''
            }
            return h('Input', {
              props: {
                placeholder: t('请输入'),
                value: params.row.end_date_day,
              },
              on: {
                'on-blur': (e) => {
                  const val = e.target.value
                  console.log('val::', val);
                  params.row.end_date_day = val;
                  this.tableData[params.index].end_date_day = val;
                }
              }
            })
          }
        },
        {
          "title": t("操作"), "key": "dataSet", "__id": "osIj2QE",
          render: (h, params) => {
            const _this = this
            if (params.row.appoint_type != 3) {
              return ''
            }
            return h('Button', {
              props: {
                type: 'primary',
                icon: 'md-add',
              },
              style: {
                backgroundColor: '#85b544',
                borderColor: '#85b544',
                // color: 'green',
                // fontWeight: 1000,
                marginLeft: '16px',
                // transform: 'scale(1.5)'
              },
              on: {
                click: () => {
                  const { qty, date_num } = _this.tableData[params.index]
                  const sum = date_num.reduce((a,b,c,d) => {
                    if (Number(b.num) < 0) {
                      $fcError(t('【指定数量】只能为正整数！'))
                      return NaN
                    } else if (isNaN(Number(b.num))) {
                      $fcError(t('【指定数量】只能为正整数！'))
                      return NaN
                    } else if (Number(b.num) > qty) {
                      $fcError(t('【指定数量】不能大于【销售数量】') + `: ${qty} ！`)
                      return NaN
                    } else {
                      return a + Number(b.num)
                    }
                  },0)
                  if (isNaN(sum)) {
                    return
                  }
                  if (isNaN(sum) || sum < 0  || Number(sum).toString().includes('.')) {
                    $fcError(t('【指定数量】只能为正整数！'))
                    return
                  }
                  const surplus = qty - sum > 0 ? qty - sum : 0
                  const newRule = { date: '', num: surplus }
                  this.handleRule(1, [newRule, params.row])
                }
              },
            }, t('添加'))
          }
        }],
      tableData: [
      /* {
        "appoint_type": 1,
        "start_date_day": "20220111",
        "end_date_day": "20220122",
        "relationIds": [123, 567, 898],
        sku_code: '12987122',
        sku_title: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        "appoint_type": 2,
        "start_date_day": "0",
        "end_date_day": "15",
        sku_code: '12987123',
        sku_title: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        "appoint_type": 3,
        "date_num": [
          {
            "date": "20220411",
            "num": 10
          },
          {
            "date": "20220416",
            "num": 10
          },
          {
            "date": "20220419",
            "num": 10
          }
        ],
        sku_code: '12987125',
        sku_title: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      } */
      ],
      btnConfig: {
        btnsite: 'left',
        buttons: [
          {
            type: 'primary',
            text: t('刷新'), // 按钮文本
            btnclick: () => {
              this.search();
            }
          }
        ]
      },
      btnConfig2: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('返回'),
            btnclick: () => {
              $fcWarn({
                title: t('提示'), // 提示
                content: t('当前修改未保存，确定返回？'), // 当前修改未保存，确定返回？
                showCancel: true,
                onOk: () => {
                  this.$parent.$parent.closeConfirm();
                }
              });
            } // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            btnclick: () => {
              this.submit();
            }
          }
        ]
      },
    };
  },
  methods: {
    handlerTableData(n) {
      console.log('handlerTableData::');
      n.forEach(it => {
        if (it.appoint_type == 3) {
          if (it.date_num.length) {
            it._expanded = true
            it.date_num.forEach((x, y) => {
              x.key = `${y}_${x.date}_${x.num}`
            })
          } else {
            it._expanded = false
          }
          it._disableExpand = false
        } else {
          it._disableExpand = true
        }
      })
      return n
    },
    selectOptionRender(h) {
      // const options = [{ sku_title: '生产日期范围', code: 1 }, { sku_title: '生产天数范围', code: 2 }, { sku_title: '生产日期和数量', code: 3 }];
      const options = [{ sku_title: t('生产日期范围'), code: 1 }, { sku_title: t('生产天数范围'), code: 2 }];
      return options.map(item => h('Option', {
        props: {
          value: item.code,
          label: item.sku_title
        }
      }));
    },
    handleRule(addOrDelete, arg = []) {
      const _this = this
      const [killIt = {}, row = {}] = arg
      const curData = JSON.parse(JSON.stringify(this.tableData))
      curData.forEach(tr => {
        if (tr.sku_code == row.sku_code) {
          if (addOrDelete == 1) { // add
            tr.date_num.push(killIt)
            console.log('+++::tr.date_num::', tr.date_num);
            return
          } else { // delete
            const { qty, date_num } = tr
            const sum = date_num.reduce((a,b,c,d) => {
              if (Number(b.num) < 0) {
                $fcError(t('【指定数量】只能为正整数！'))
                return NaN
              } else if (isNaN(Number(b.num))) {
                $fcError(t('【指定数量】只能为正整数！'))
                return NaN
              } else {
                return a + Number(b.num)
              }
            },0)
            if (isNaN(sum) || sum < 0  || Number(sum).toString().includes('.')) {
              $fcError(t('【指定数量】只能为正整数！'))
              return
            }
            const curNum = Number(killIt.num)
            const lastNum = tr.date_num[tr.date_num.length-1].num
            tr.date_num[tr.date_num.length-1].num = Number(lastNum) + curNum
          }
          const index = tr.date_num.findIndex(i => i.key == killIt.key)
          console.log('---::index::', index);
          tr.date_num.splice(index, 1) // 直接改变原数组
          console.log('---::tr.date_num::', tr.date_num);
        }
      })
      this.$set(this, 'tableData', curData)
    },
    async search() {
      const self = this;
      self.loading = true;
      const ids = self.componentData.ids
      const res = await self.service.orderCenter.selectExpiryDate({ids});
      self.loading = false;
      if (res.data.code === 0) {
        const lists = res.data.data;
        lists.forEach(it => {
          it.appoint_type = 1
          // it.start_date_day = ''
          // it.end_date_day = ''
          it.date_num = []
        })
        self.tableData = lists;
        // self.tableData = self.handlerTableData(lists);
      }
    },
    async submit() {
      const self = this;
      const ids = self.componentData.ids
      const data = self.tableData
      let flag = true
      data.forEach((it,index) => {
        if (it.appoint_type == 1) {
          if (it.start_date_day.length > 8) {
            $fcError(t('当前第{}行数据的 开始生产日期为【{}】，填写错误，请重新填写！', [index+1, it.start_date_day]))
            flag = false
            return
          }
          if (it.end_date_day.length > 8) {
            $fcError(t('当前第{}行数据的 结束生产日期为【{}】，填写错误，请重新填写！', [index+1, it.end_date_day]))
            flag = false
            return
          }
        } else if (it.appoint_type == 3) {
          it.date_num && it.date_num.forEach((x,y) => {
            if (x.date.length > 8) {
              $fcError(t('当前第{}行数据的第{}条明细 生产日期为【{}】，填写错误，请重新填写！', [index+1, y+1, x.date]))
              flag = false
              return
            }
          })
        }
      })
      if (!flag) return
      const res = await self.service.orderCenter.confirmExpiryDate(data);
      if (res.data.code === 0 && res.data.data) {
        self.$parent.$parent.$parent.getData();
        self.selection = [];
        self.$parent.close();
        window.dispatchEvent(new CustomEvent('addTask',{
          detail: {
            type: 'notice',
          },
        }))
      }
    },
    // 选中某一项时触发
    onSelect() { },
    // 取消选中某一项时触发
    onSelectCancel() { },
    // 点击全选时触发
    onSelectAll() { },
    // 点击取消全选时触发
    onSelectAllCancel() { },
    // 单击某一行时触发
    onRowClick(row) {
      this.selection = row;
    },
    // 双击某行时触发
    onRowDblclick(row) {
      this.selection = row;
    },
    // 分页change 事件
    pageChange(val) {
      this.tableConfig.current = val;
      this.search();
    },
    // 切换分页条数
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.search();
    },
    onKeyDown(e) {
      if (e.keyCode == 27) {
        this.$parent.$parent.closeConfirm();
      }
    }
  },
  mounted() {
    this.search();
  },
  created() { }
};

</script>

<style lang="less" scoped>
.SED {
  .ark_table {
    margin: 12px 0;
    /deep/.ark-table {
      td.ark-table-expanded-cell {
        padding: 0 !important;
      }
      .ark-btn span {
        vertical-align: middle;
      }
      .ark-input-wrapper,
      .el-input {
        input {
          border-top: none;
          border-left: none;
          border-right: none;
          border-bottom-color: #515a6e;
          border-radius: 0;
          text-align: left;
          padding: 0;
          padding-left: 6px;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
}
// @import '~@/css/pages/orderCenter/orderManager/replaceTheGoods.less';
</style>
